import React from 'react'

import { useShared } from '../../hooks/useShared'
import MainSection from '../../components/sections/MainSection';
import APopover from '../../components/partials/APopover';

const TABLE_HEAD = ["#", "شماره آينوايس", "تاريخ صدور", "اسم شرکت", '  کشور مقصد', 'اجانس', 'تاريخ '];
const breadcrumbs = [{ name: 'صادرات', link: null }]


const searchInputFields = [
    { label: 'شرکت', name: 'sCompany', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-3', options: [] },
    { label: 'ارسال به کشور', name: 'shipping_state', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-3', options: [] },
    { label: 'تاريخ ارسال', name: 'shipping_date', type: 'pdate', roles: [1], icon: 'text-outline', className: 'md:col-span-2', },
    { label: 'شماره اينوايس', name: 'invoice_number', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-2', },
    { label: 'ايجاد کننده', name: 'creator_id', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-2', },

];


export default function Exports() {

    const { com, navigate, models, } = useShared();

    const goToInvoicesPage = (model) => {
        navigate(`/db/invoices/${model?.id}`)
    }

    const getTableData = () => {
        return (<tbody className=''>
            {models?.data?.map((r, i) => {
                return (
                    <tr key={i}>
                        <td >{models?.from + i}</td>
                        <td className='text-center'> <span className=' cursor-pointer text-blue-600 underline' onClick={() => goToInvoicesPage(r)}>{r.invoice_number}</span></td>
                        <td >{com.dateConvert(r?.shipping_date, false)}</td>
                        <td>
                            <span>{r?.from?.name_af}</span>   <APopover v={{ data: shippingPopup(r?.from), className: "mt-3", btn: '!bg-green-900/30', iconCss: '!text-green-900' }} />
                        </td>
                        <td >
                            <span>{r?.shipping_state?.label}</span>    <APopover v={{ data: shippingPopup(r, false), className: "mt-3", btn: '!bg-blue-900/30', iconCss: '!text-blue-900' }} />
                        </td>

                        <td style={{ direction: 'rtl' }}>
                            {r?.tariff?.items?.map((item, j) => {
                                return <span key={j} className='ml-1'>{item?.category.label}{j < r?.company?.export_items?.length - 1 && <span >،</span>} </span>
                            })}
                            <APopover v={{ data: itemsPopup(r?.tariff?.items), className: "mt-3" }} />
                        </td>



                        <td style={{ direction: 'ltr' }}>{com.dateConvert(r?.created_at, false, true)}</td>

                    </tr>
                )
            })}
        </tbody>)
    }


    const itemsPopup = (items) => <table className=" gTable  ">
        <thead >
            <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                <th>#</th>
                <th>جنس</th>
                <th>متراژ</th>
                <th>قيمت فی متر (واقعي)</th>
                <th>قيمت فی متر (حمايوی)</th>

                <th>مچموعه (واقعی)</th>
                <th>مچموعه (حمايوی)</th>
            </tr>
        </thead>
        <tbody >
            {items?.map((item, i) => (
                <tr key={i + 1}>
                    <td>{1 + i}</td>
                    <td>{item?.category?.label} </td>
                    <td> {item?.quantity} </td>
                    <td> {item?.real_price_per_unit}  ؋</td>
                    <td> {item?.price_per_unit}  ؋</td>
                    <td> {com?.NumberFormatter(item?.quantity * item?.real_price_per_unit)} ؋</td>
                    <td> {com?.NumberFormatter(item?.quantity * item?.price_per_unit)} ؋</td>
                </tr>
            ))}
        </tbody>
    </table>

    const shippingPopup = (r, flag = true) =>
        <> {flag ?

            <table className=" gTable  ">
                <tbody>
                    <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'><th colSpan={2}>From</th></tr>
                    <tr><th>Name</th><td>{r?.name_af}</td></tr>
                    <tr><th>Address</th><td>{r?.address}</td></tr>
                    <tr><th>TIN No. </th><td>{r?.tin_number}</td></tr>
                    <tr><th>License No. </th><td>{r?.license_number}</td></tr>
                    <tr><th>Owner</th><td>{r?.owner?.label}</td></tr>
                    <tr><th>Email</th><td>{r?.email}</td></tr>
                </tbody>
            </table> : <table className=" gTable  ">
                <tbody>
                    <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'><th colSpan={2}>Shipping To</th></tr>
                    <tr><th>Name</th><td>{r?.shipping_name}</td></tr>
                    <tr><th>Address</th><td>{r?.shipping_address}</td></tr>
                    <tr><th>City</th><td>{r?.shipping_city}</td></tr>
                    <tr><th>State</th><td>{r?.shipping_state?.name} - {r?.shipping_state?.label}</td></tr>
                    <tr><th>Phone</th><td>{r?.shipping_phone}</td></tr>
                    <tr><th>Email</th><td>{r?.shipping_email}</td></tr>
                </tbody>
            </table>

        }

        </>



    return (
        <MainSection v={{
            searchInputFields,
            TABLE_HEAD,
            breadcrumbs,
            tableData: getTableData(),
            tableTitle: 'لست صادرات',
            url: "exports",
            mUrl: { getAll: 'exports' },
            advanceSearch: 'exports',
            excel: { show: true }
        }} />
    )

}
